module.exports = __webpack_public_path__ + "img/logo-tsukigo-horizontal_nuage-go.5c326c17.png";